import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogout } from './Auth.hooks';

export function Logout() {
	const navigate = useNavigate();
	const isLoading = useLogout();
	useEffect(() => {
		if (!isLoading) {
			navigate('/');
		}
	}, [isLoading]);
	return <div>Loading</div>;
}
